import VacationEditor from './VacationEditor.jsx';

export default VacationEditor;

